export const BOOK_VEHICLE = "BOOK_VEHICLE";
export const GET_VEHICLE_DETAILS = "GET_VEHICLE_DETAILS";
export const SAVE_VEHICLE_DETAILS = "SAVE_VEHICLE_DETAILS";
export const CLEAR_VEHICLE_DETAILS = "CLEAR_VEHICLE_DETAILS";

export const BOOK_VEHICLE_INCREASE_QTY = "BOOK_VEHICLE_INCREASE_QTY";
export const BOOK_VEHICLE_DECREASE_QTY = "BOOK_VEHICLE_DECREASE_QTY";

export const CLEAR_BOOKED_VEHICLE = "CLEAR_BOOKED_VEHICLE";

export const MAKE_VEHICLE_RESERVATION = "MAKE_VEHICLE_RESERVATION";
export const CLEAR_VEHICLE_RESERVATION = "CLEAR_VEHICLE_RESERVATION";
export const RESERVATION_QTY_INCREASE = "RESERVATION_QTY_INCREASE";
export const RESERVATION_QTY_DECREASE = "RESERVATION_QTY_DECREASE";

export const MAKE_VEHICLE_PAYMENT = "MAKE_VEHICLE_PAYMENT";
export const CLEAR_VEHICLE_PAYMENT = "CLEAR_VEHICLE_PAYMENT";

export const GET_VEHICLE_PAYMENT_LIST = "GET_VEHICLE_PAYMENT_LIST";
export const LOAD_MORE_VEHICLE_PAYMENT_LIST = "LOAD_MORE_VEHICLE_PAYMENT_LIST";
export const GET_VEHICLE_PAYMENT_DETAILS = "GET_VEHICLE_PAYMENT_DETAILS";

export const DELETE_VEHICLE_PAYMENT = "DELETE_VEHICLE_PAYMENT";
export const CLEAR_DELETED_VEHICLE_PAYMENT = "CLEAR_DELETED_VEHICLE_PAYMENT";

export const FINISH_PAYMENT = "FINISH_PAYMENT";
export const RETURN_VEHICLE = "RETURN_VEHICLE";

export const SEARCH_VEHICLE = "SEARCH_VEHICLE";
export const LOAD_MORE_SEARCH_VEHICLE_LIST = "LOAD_MORE_SEARCH_VEHICLE_LIST";
export const DATA_TO_SEARCH_VEHICLE = "DATA_TO_SEARCH_VEHICLE";
export const CLEAR_SEARCH_VEHICLE_LIST = "CLEAR_SEARCH_VEHICLE_LIST";

export const GET_VEHICLE_LIST_EVERY_TYPE = "GET_VEHICLE_LIST_EVERY_TYPE";
